
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"9","height":"13","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.172 11.617c.453-.573.89-1.276 1.312-2.11l2.508-4.913c-.265-1.042-.515-1.774-.75-2.196-.229-.421-.583-.632-1.062-.632-.443 0-.865.218-1.266.656L.531 2C1.25 1.214 1.961.82 2.664.82c.49 0 .87.14 1.14.422.272.276.498.719.68 1.328.183.61.44 1.787.774 3.532.432 2.276.768 3.713 1.008 4.312.244.594.533.89.867.89.24 0 .46-.083.664-.25l.297.47c-.516.4-.98.601-1.39.601-.584 0-1-.3-1.25-.898-.25-.6-.6-2.211-1.048-4.836H4.36A134.955 134.955 0 001.758 12H.172v-.383z","fill":"currentColor"}})])
          )
        }
      }
    